import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import SubHeader from "../../../../components/SubHeader";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import ItemsList from "./ItemsList";
import { useAlert } from "../../../../context/AlertContext";
const ItemsPage = ({ handleFilter, data, totalCount, handleDelete, page, setPage }) => {
  const theme = useTheme();
  const navigate = useNavigate()
  const { showAlert } = useAlert();

  const handleNavigate = (path) => {
    navigate(path)
  }

  const showPopup = () => {
    showAlert("Development In Progress", "success");
  }

  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={styles.leaveHeading}>Inventory</Typography>
        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Box>
            <Button variant="contained" color="success" sx={styles.checkinBtn} onClick={() => handleNavigate("/dashboard/addNewItem")}>
              {"+ Add Inventory"}
            </Button>
            <Button variant="contained" color="success" sx={styles.checkinBtn} onClick={showPopup}>
              {"+ Add Special Price"}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title="Inventory List"
          search={true}
          sortBy={true}
          onchange={(txt) => handleFilter(txt)}
          handleSort={(txt) => handleFilter("", txt)}
        />
        <ItemsList data={data} page={page} setPage={setPage} totalCount={totalCount} handleDelete={handleDelete} />
      </Box>
    </>
  );
};

export default ItemsPage;
